var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _rect3, _rect4, _path9, _rect5, _rect6, _path10, _rect7, _path11, _rect8, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 320,
    viewBox: "0 0 282 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.887695 118.447V201.472L152.161 316.854C153.917 318.193 156.063 318.918 158.271 318.918H270.45C276.014 318.918 280.524 314.408 280.524 308.844V262.513C280.524 256.949 276.014 252.438 270.45 252.438H165.848C163.451 252.438 161.134 251.584 159.311 250.029L92.7762 193.289H270.946C276.51 193.289 281.021 188.778 281.021 183.215V136.883C281.021 131.319 276.51 126.809 270.946 126.809H92.5655L159.311 69.8889C161.134 68.334 163.451 67.48 165.848 67.48H270.45C276.014 67.48 280.524 62.9695 280.524 57.4056V11.0743C280.524 5.51043 276.014 1 270.45 1H158.271C156.063 1 153.917 1.72521 152.161 3.06412L0.887695 118.447Z",
    fill: "url(#paint0_linear_598_15817)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.887695 118.447L0.452358 117.876L0.169865 118.091V118.447H0.887695ZM0.887695 201.472H0.169865V201.827L0.452358 202.042L0.887695 201.472ZM152.161 316.854L152.597 316.283L152.161 316.854ZM159.311 250.029L159.776 249.483L159.311 250.029ZM92.7762 193.289V192.571H90.8282L92.3104 193.835L92.7762 193.289ZM92.5655 126.809L92.0997 126.263L90.6175 127.527H92.5655V126.809ZM159.311 69.8889L158.845 69.3427L159.311 69.8889ZM152.161 3.06412L152.597 3.63487V3.63487L152.161 3.06412ZM0.169865 118.447V201.472H1.60553V118.447H0.169865ZM0.452358 202.042L151.726 317.425L152.597 316.283L1.32303 200.901L0.452358 202.042ZM151.726 317.425C153.606 318.859 155.906 319.636 158.271 319.636V318.2C156.221 318.2 154.227 317.527 152.597 316.283L151.726 317.425ZM158.271 319.636H270.45V318.2H158.271V319.636ZM270.45 319.636C276.41 319.636 281.242 314.804 281.242 308.844H279.807C279.807 314.011 275.618 318.2 270.45 318.2V319.636ZM281.242 308.844V262.513H279.807V308.844H281.242ZM281.242 262.513C281.242 256.552 276.41 251.72 270.45 251.72V253.156C275.618 253.156 279.807 257.345 279.807 262.513H281.242ZM270.45 251.72H165.848V253.156H270.45V251.72ZM165.848 251.72C163.622 251.72 161.47 250.927 159.776 249.483L158.845 250.576C160.798 252.241 163.281 253.156 165.848 253.156V251.72ZM159.776 249.483L93.2419 192.743L92.3104 193.835L158.845 250.576L159.776 249.483ZM92.7762 194.007H270.946V192.571H92.7762V194.007ZM270.946 194.007C276.907 194.007 281.739 189.175 281.739 183.215H280.303C280.303 188.382 276.114 192.571 270.946 192.571V194.007ZM281.739 183.215V136.883H280.303V183.215H281.739ZM281.739 136.883C281.739 130.923 276.907 126.091 270.946 126.091V127.527C276.114 127.527 280.303 131.716 280.303 136.883H281.739ZM270.946 126.091H92.5655V127.527H270.946V126.091ZM93.0313 127.355L159.776 70.4351L158.845 69.3427L92.0997 126.263L93.0313 127.355ZM159.776 70.4351C161.47 68.991 163.622 68.1978 165.848 68.1978V66.7621C163.281 66.7621 160.798 67.6771 158.845 69.3427L159.776 70.4351ZM165.848 68.1978H270.45V66.7621H165.848V68.1978ZM270.45 68.1978C276.41 68.1978 281.242 63.366 281.242 57.4056H279.807C279.807 62.5731 275.618 66.7621 270.45 66.7621V68.1978ZM281.242 57.4056V11.0743H279.807V57.4056H281.242ZM281.242 11.0743C281.242 5.11399 276.41 0.28217 270.45 0.28217V1.71783C275.618 1.71783 279.807 5.90688 279.807 11.0743H281.242ZM270.45 0.28217H158.271V1.71783H270.45V0.28217ZM158.271 0.28217C155.906 0.28217 153.606 1.05906 151.726 2.49336L152.597 3.63487C154.227 2.39137 156.221 1.71783 158.271 1.71783V0.28217ZM151.726 2.49336L0.452358 117.876L1.32303 119.017L152.597 3.63487L151.726 2.49336Z",
    fill: "#DBD6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.094 39.5259V28.2451H181.519C184.09 28.2451 185.555 29.8188 185.555 32.0469C185.555 34.3062 184.059 35.8487 181.457 35.8487H179.431V39.5259H177.094ZM179.431 33.9634H181.083C182.47 33.9634 183.14 33.1843 183.14 32.0469C183.14 30.925 182.47 30.1616 181.083 30.1616H179.431V33.9634ZM191.008 39.5259H187.035V28.2451H191.055C194.452 28.2451 196.524 30.3641 196.524 33.8699C196.524 37.4068 194.452 39.5259 191.008 39.5259ZM189.372 37.5159H190.915C193.065 37.5159 194.187 36.394 194.187 33.8699C194.187 31.3613 193.065 30.255 190.93 30.255H189.372V37.5159ZM198.222 39.5259V28.2451H205.654V30.1771H200.559V32.9194H205.171V34.8515H200.559V39.5259H198.222Z",
    fill: "#825DFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.094 165.742V154.461H184.666V156.393H179.431V159.135H184.277V161.067H179.431V163.81H184.682V165.742H177.094ZM188.359 157.281L189.933 160.257L191.538 157.281H193.922L191.444 161.504L193.984 165.742H191.616L189.933 162.797L188.281 165.742H185.882L188.406 161.504L185.975 157.281H188.359ZM198.752 165.913C196.165 165.913 194.576 164.23 194.576 161.55C194.576 158.933 196.181 157.172 198.658 157.172C200.887 157.172 202.632 158.574 202.632 161.457V162.111H196.851C196.851 163.389 197.615 164.184 198.799 164.184C199.578 164.184 200.139 163.841 200.372 163.327H202.569C202.242 164.885 200.84 165.913 198.752 165.913ZM196.851 160.662H200.45C200.45 159.634 199.734 158.902 198.705 158.902C197.646 158.902 196.89 159.688 196.851 160.662ZM206.387 154.461V165.742H204.081V154.461H206.387Z",
    fill: "#825DFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.094 290.873V279.592H179.431V284.266H184.324V279.592H186.676V290.873H184.324V286.198H179.431V290.873H177.094ZM190.198 290.873L187.892 282.412H190.229L191.553 288.13H191.631L193.018 282.412H195.308L196.711 288.099H196.789L198.098 282.412H200.435L198.113 290.873H195.682L194.218 285.497H194.109L192.644 290.873H190.198ZM201.603 294.051V282.412H203.878V283.83H203.972C204.283 283.144 204.969 282.303 206.387 282.303C208.256 282.303 209.815 283.752 209.815 286.65C209.815 289.47 208.319 291.013 206.387 291.013C205 291.013 204.299 290.218 203.972 289.517H203.909V294.051H201.603ZM203.863 286.634C203.863 288.161 204.517 289.174 205.654 289.174C206.839 289.174 207.462 288.13 207.462 286.634C207.462 285.154 206.839 284.141 205.654 284.141C204.501 284.141 203.863 285.107 203.863 286.634Z",
    fill: "#825DFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.952 27.1092C223.952 21.5509 223.952 18.7718 225.034 16.6489C225.985 14.7814 227.504 13.2632 229.371 12.3117C231.494 11.23 234.273 11.23 239.831 11.23H251.95C257.508 11.23 260.287 11.23 262.41 12.3117C264.277 13.2632 265.796 14.7814 266.747 16.6489C267.829 18.7718 267.829 21.5509 267.829 27.1092V39.2275C267.829 44.7858 267.829 47.5649 266.747 49.6879C265.796 51.5553 264.277 53.0736 262.41 54.0251C260.287 55.1068 257.508 55.1068 251.95 55.1068H239.831C234.273 55.1068 231.494 55.1068 229.371 54.0251C227.504 53.0736 225.985 51.5553 225.034 49.6879C223.952 47.5649 223.952 44.7858 223.952 39.2275V27.1092Z",
    fill: "#B30B00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.489 36.1418C256.441 33.8953 250.858 34.8781 249.509 35.0185C247.597 33.0529 246.248 30.8239 245.702 29.9815C246.385 27.8754 246.931 25.5061 246.931 23.2596C246.931 21.1535 246.112 19.0649 243.944 19.0649C243.124 19.0649 242.441 19.4862 242.031 20.1882C241.075 21.8731 241.485 25.2252 242.987 28.7178C242.168 31.2451 240.802 35.0185 239.18 37.9495C236.995 38.7919 232.232 41.0209 231.822 43.5482C231.685 44.2502 231.958 45.0926 232.505 45.5139C233.051 46.0755 233.734 46.2159 234.417 46.2159C237.268 46.2159 240.136 42.1617 242.185 38.5111C243.824 37.9495 246.402 37.1071 248.997 36.6859C251.985 39.494 254.716 39.8976 256.082 39.8976C257.994 39.8976 258.677 39.0552 258.933 38.3532C259.292 37.6862 259.036 36.7034 258.489 36.1418ZM256.577 37.5458C256.441 38.1075 255.758 38.6691 254.529 38.3883C253.026 37.9671 251.677 37.265 250.585 36.2822C251.541 36.1418 253.846 35.861 255.485 36.1418C256.031 36.2822 256.714 36.7034 256.577 37.5458ZM243.363 20.7498C243.5 20.469 243.773 20.3286 244.046 20.3286C244.729 20.3286 244.865 21.171 244.865 21.8731C244.729 23.5579 244.456 25.3656 243.909 26.9101C242.817 23.8387 242.953 21.5922 243.363 20.7498ZM243.226 36.563C243.909 35.2993 244.729 32.93 245.002 32.0876C245.685 33.3512 246.914 34.7553 247.46 35.4398C247.597 35.3169 245.139 35.861 243.226 36.563ZM238.6 39.7923C236.705 42.8637 234.929 44.8294 233.836 44.8294C233.7 44.8294 233.427 44.8294 233.29 44.689C233.154 44.4082 233.017 44.1274 233.154 43.8465C233.29 42.7233 235.475 41.1788 238.6 39.7923Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 224.009,
    y: 138.776,
    width: 43.8768,
    height: 43.8768,
    rx: 6.648,
    fill: "white",
    stroke: "#EBEFF6",
    strokeWidth: 1.9944
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237.962,
    y: 147.077,
    width: 24.0714,
    height: 28.0833,
    rx: 2.6592,
    fill: "#2FB776"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.962 168.139H262.033V172.501C262.033 173.969 260.843 175.16 259.374 175.16H240.621C239.152 175.16 237.962 173.969 237.962 172.501V168.139Z",
    fill: "url(#paint1_linear_598_15817)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249.998,
    y: 161.119,
    width: 12.0357,
    height: 7.02082,
    fill: "#229C5B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 249.998,
    y: 154.098,
    width: 12.0357,
    height: 7.02082,
    fill: "#27AE68"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.962 149.736C237.962 148.267 239.152 147.077 240.621 147.077H249.997V154.098H237.962V149.736Z",
    fill: "#1D854F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 237.962,
    y: 154.097,
    width: 12.0357,
    height: 7.02082,
    fill: "#197B43"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 237.962,
    y: 161.118,
    width: 12.0357,
    height: 7.02082,
    fill: "#1B5B38"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M237.962 158.086C237.962 155.883 239.748 154.097 241.951 154.097H246.009C248.212 154.097 249.997 155.883 249.997 158.086V168.162C249.997 170.365 248.212 172.151 246.009 172.151H237.962V158.086Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 229.938,
    y: 152.092,
    width: 18.0535,
    height: 18.0535,
    rx: 2.6592,
    fill: "url(#paint2_linear_598_15817)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M242.978 166.133L240.152 161.018L242.854 156.104H240.648L238.98 159.242L237.339 156.104H235.064L237.78 161.018L234.954 166.133H237.16L238.938 162.809L240.703 166.133H242.978Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 224.009,
    y: 263.906,
    width: 43.8768,
    height: 43.8768,
    rx: 6.648,
    fill: "white",
    stroke: "#EBEFF6",
    strokeWidth: 1.9944
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M246.612 300.22H257.831C259.207 300.22 260.324 299.104 260.324 297.727V293.363H246.612V300.22Z",
    fill: "#98D0F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M246.612 293.368H260.324V286.511H246.612V293.368Z",
    fill: "url(#paint3_linear_598_15817)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.612 286.51H260.324V279.654H246.612V286.51Z",
    fill: "url(#paint4_linear_598_15817)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M246.612 279.655H260.324V275.291C260.324 273.914 259.207 272.798 257.831 272.798H246.612V279.655Z",
    fill: "url(#paint5_linear_598_15817)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M246.612 300.221V272.798H251.598C251.24 274.891 250.396 280.074 249.786 285.797C249.139 291.875 248.843 298.126 248.757 300.221H246.612Z",
    fill: "url(#paint6_linear_598_15817)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M236.391 272.798H246.612V300.221H236.391C235.463 300.221 234.999 300.221 234.623 300.099C234.249 299.977 233.909 299.769 233.631 299.491C233.352 299.212 233.144 298.872 233.023 298.498C232.901 298.123 232.901 297.659 232.901 296.731V276.288C232.901 275.36 232.901 274.896 233.023 274.52C233.144 274.146 233.353 273.806 233.631 273.528C233.909 273.25 234.249 273.041 234.623 272.92C234.999 272.798 235.463 272.798 236.391 272.798H236.391Z",
    fill: "url(#paint7_linear_598_15817)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M243.921 278.377H240.473C240.486 278.205 240.5 277.91 240.5 277.552V276.741H239.018V277.552C239.018 277.91 239.036 278.205 239.045 278.377H235.592V279.773H237.309C236.752 280.185 236.453 280.869 236.453 281.73C236.453 283.385 237.767 284.739 239.757 284.739C241.746 284.739 243.06 283.389 243.06 281.73C243.06 280.865 242.716 280.158 242.204 279.773H243.921V278.377ZM239.757 283.348C238.683 283.348 237.935 282.51 237.935 281.522C237.935 280.534 238.683 279.696 239.757 279.696C240.831 279.696 241.578 280.534 241.578 281.522C241.578 282.51 240.831 283.348 239.757 283.348Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_598_15817",
    x1: 298.944,
    y1: 168.346,
    x2: -291.797,
    y2: 168.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#DAD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_598_15817",
    x1: 237.962,
    y1: 171.649,
    x2: 262.033,
    y2: 171.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_598_15817",
    x1: 229.938,
    y1: 161.119,
    x2: 247.992,
    y2: 161.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_598_15817",
    x1: 253.468,
    y1: 293.368,
    x2: 253.468,
    y2: 286.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37A5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115015,
    stopColor: "#42ADFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_598_15817",
    x1: 253.468,
    y1: 286.51,
    x2: 253.468,
    y2: 279.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125267,
    stopColor: "#0082E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_598_15817",
    x1: 253.468,
    y1: 279.655,
    x2: 253.468,
    y2: 272.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00458A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114689,
    stopColor: "#004D99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_598_15817",
    x1: 246.919,
    y1: 279.952,
    x2: 249.908,
    y2: 280.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_598_15817",
    x1: 239.756,
    y1: 272.798,
    x2: 239.756,
    y2: 300.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramRight);
export default __webpack_public_path__ + "static/media/diagram-right.35018029eaa2a85c71dae08c101a417b.svg";
export { ForwardRef as ReactComponent };